/* eslint-disable @typescript-eslint/no-unused-vars */
import { useFormContext } from "components/Form";
import { Button } from "components/Button";
import { useStepperContext } from "components/Steps";

import { ArrowForward as IconArrowNext } from "@material-ui/icons";
import { ArrowBack as IconArrowBack } from "@material-ui/icons";

import * as S from "./styles";
import { Input } from "components/hookForm/Input";
import { InputMask } from "components/hookForm/InputMask";
import { DefaultFooter } from "../../../components/DefaultFooter";
import { MediaMatch } from "components/MediaMatch";

export function PersonalDataForm() {
  const {
    methodsForm: {
      formState: { errors },
    },
    validateFields,
  } = useFormContext();

  const { goToNextStep, goToPreviousStep } = useStepperContext();

  async function handleNextStep() {
    const fields = ["name", "email", "phoneNumber"];
    const isFieldsValids = await validateFields(fields);

    if (isFieldsValids) {
      goToNextStep();
    }
  }

  return (
    <S.Container>
      <S.Title>
        Estamos quase lá. Precisamos dessas últimas informações para finalizar
        os cálculos.
      </S.Title>

      <S.WrapperForm>
        <div className="grid-3">
          <Input
            name="name"
            customLabel="Nome completo*"
            placeholder="Informe o nome completo"
            error={!!errors.name}
            helperText={errors.name?.message}
          />

          <InputMask
            masks={["999.999.999-99"]}
            name="cpf"
            customLabel="CPF"
            placeholder="Somente os números"
            error={!!errors.cpf}
            helperText={errors.cpf?.message}
            type="tel"
          />

          <Input
            name="email"
            customLabel="E-mail*"
            placeholder="seuemail@email.com.br"
            error={!!errors.email}
            helperText={errors.email?.message}
            type="email"
          />
        </div>

        <div className="grid-3">
          <div></div>
          <InputMask
            masks={["(99) 9999-9999", "(99) 9 9999-9999"]}
            name="phoneNumber"
            customLabel="Telefone de contato*"
            placeholder="(DDD) 99999-9999"
            error={!!errors.phoneNumber}
            helperText={errors.phoneNumber?.message}
            type="tel"
          />
          <div></div>
        </div>
      </S.WrapperForm>

      <S.NextStepMessage>
        Confira agora mesmo o resultado da sua simulação!
      </S.NextStepMessage>

      <S.WrapperButtons>
        <Button
          onClick={goToPreviousStep}
          startIcon={<IconArrowBack />}
          variant="outlined"
        >
          VOLTAR
        </Button>
        <Button onClick={handleNextStep} endIcon={<IconArrowNext />}>
          AVANÇAR
        </Button>
      </S.WrapperButtons>

      <MediaMatch greaterThan="medium">
        <DefaultFooter />
      </MediaMatch>
    </S.Container>
  );
}
